import { searchFilter } from '../../utils/searchFilter';
import { ApiGroupModel } from './group-sidebar.component';

export class GroupSidebarListController {
    public groups!: ApiGroupModel[];
    public filter!: string;

    public filteredGroups: any = [];

    $onInit() {
        this.updateFilters();
    }

    $onChanges() {
        this.updateFilters();
    }

    public updateFilters() {
        // todo: typings

        const prepareParentGroup = (group: ApiGroupModel) => ({
            ...group,
            subgroups: [],
        });
        const createTree = (groups: ApiGroupModel[]) => {
            // create hash of PARENT groups by id
            // also adds subgroups: [] to each group
            const parents = groups
                .filter((group) => !Boolean(group.parent_id))
                .reduce(
                    (parents, current) => ({
                        ...parents,
                        [current.id]: prepareParentGroup(current),
                    }),
                    {}
                ) as any;

            groups
                // get subgroups only
                .filter((group) => Boolean(group.parent_id))
                .forEach((group) => {
                    const { parent_id } = group;

                    if (!parents[parent_id]) {
                        parents[group.id] = prepareParentGroup(group);
                        return;
                    }

                    parents[parent_id].subgroups.push(group);
                });

            return Object.values(parents) as ApiGroupModel[];
        };

        const filterGroups = (groups: ApiGroupModel[]): ApiGroupModel[] => {
            // no filter specified - add all groups
            if (!this.filter) {
                return groups;
            }
            const filtered = [];

            for (const group of groups) {
                const subgroups = group.subgroups ? filterGroups(group.subgroups) : [];

                // check if group name matches filter or
                // if subgroup name matched filter - the parent should also be shown
                if (searchFilter(this.filter, group.name) || subgroups.length) {
                    filtered.push({
                        ...group,
                        subgroups,
                    });
                }
            }

            return filtered;
        };

        this.filteredGroups = filterGroups(createTree(this.groups));
    }
}

angular.module('tradersyard').component('tyGroupSidebarList', {
    template: `
        <div class="group_sidebar_list">
            <div
                ng-if="!$ctrl.filteredGroups.length && $ctrl.groups.length"
                class="group_sidebar_message"
            >
                No results found
            </div>
            <ty-group-sidebar-list-item
              filter="$ctrl.filter"
              flatlist="$ctrl.flatlist"
              add-button="$ctrl.addButton"
              ng-repeat="group in $ctrl.filteredGroups track by group.id" group="group"
              ng-if="$ctrl.filteredGroups.length"
            />
        </div>
    `,
    bindings: {
        groups: '<',
        filter: '<',
        flatlist: '<',
        addButton: '<',
    },
    controller: GroupSidebarListController,
});
